import { Token } from "~/types";
import { RankingType, ColumnSortType } from "~/pages/constants";
import get from "lodash-es/get";
import { isLessThan } from "~/utils/calcNumber";

export const sortTokenList = (
    list: Array<Token>,
    priceSortType: ColumnSortType,
    rankingType: RankingType,
    volumeSortType: ColumnSortType
) => {
    if (
        priceSortType === ColumnSortType.None &&
        volumeSortType === ColumnSortType.None
    ) {
        return list;
    }

    const sortedKey =
        priceSortType !== ColumnSortType.None
            ? "token_market.change"
            : rankingType === RankingType.Txn
              ? "token_market.txn"
              : "token_market.volume_value";
    const sortType =
        priceSortType !== ColumnSortType.None ? priceSortType : volumeSortType;

    return [...list].sort((a, b) => {
        if (sortType === ColumnSortType.Descending) {
            return isLessThan(get(a, sortedKey), get(b, sortedKey)) ? 1 : -1;
        } else if (sortType === ColumnSortType.Ascending) {
            return isLessThan(get(b, sortedKey), get(a, sortedKey)) ? 1 : -1;
        } else {
            return 0;
        }
    });
};
